// src/context/AuthContext.jsx
import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const API = process.env.REACT_APP_API_URL;

  // 🔄 Hent innlogget bruker ved refresh hvis token finnes
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      axios
        .get(`${API}/users/me`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          const me = { ...res.data, token };
          setUser(me);
          try {
            localStorage.setItem('user', JSON.stringify(me));
          } catch {}
        })
        .catch(() => {
          setUser(null);
          localStorage.removeItem('token');
          localStorage.removeItem('user');
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [API]);

  const login = async (email, password) => {
    try {
      const response = await axios.post(`${API}/auth/login`, {
        email,
        password,
      });

      const { token } = response.data;
      localStorage.setItem('token', token);

      const meRes = await axios.get(`${API}/users/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const me = { ...meRes.data, token };
      setUser(me);
      try {
        localStorage.setItem('user', JSON.stringify(me));
      } catch {}

      return me.role;
    } catch (err) {
      throw new Error(err.response?.data?.error || 'Feil e-post eller passord');
    }
  };

  /**
   * register(form):
   *  forventer feltene:
   *  { name, email, password, phone, address, postal_code, city, isBusiness, orgNumber }
   */
  const register = async (form) => {
    try {
      const payload = {
        name: form.name,
        email: form.email,
        password: form.password,
        phone: form.phone || null,
        address: form.address || null,
        postal_code: form.postal_code || null,
        city: form.city || null,
        isBusiness: !!form.isBusiness,
        orgNumber: form.isBusiness ? form.orgNumber || null : null,
      };

      const response = await axios.post(`${API}/auth/register`, payload);

      const { token } = response.data;
      localStorage.setItem('token', token);

      const meRes = await axios.get(`${API}/users/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const me = { ...meRes.data, token };
      setUser(me);
      try {
        localStorage.setItem('user', JSON.stringify(me));
      } catch {}

      return me.role;
    } catch (err) {
      throw new Error(err.response?.data?.error || 'Registrering feilet.');
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{ user, login, logout, register, loading }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
